import { mchenryServiceCoreUrl } from "../../main";
import esriConfig from "@arcgis/core/config";

export type AuthState = {
  isLocal: boolean;
  isAuthLoading: boolean;
  isAuthenticated: boolean;
  userInfo: any;
};

export type AuthActions = {
  checkToken: () => Promise<boolean>;
  checkLogin: (username?: string, password?: string) => Promise<boolean>;
  checkIsLocal: () => Promise<boolean>;
  refreshAppToken: (token: string) => Promise<void>;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  logout: () => void;
  setUserInfo: (userInfo: any) => void;
};
export const createAuthSlice = (set, get): AuthState & AuthActions => ({
  checkIsLocal: async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const json = await res.json();
      const compareIp = (ip1: string, ip2: string) => {
        const ip1Parts = ip1.split(".");
        const ip2Parts = ip2.split(".");
        for (let i = 0; i < 3; i++) {
          if (ip1Parts[i] !== ip2Parts[i]) {
            return false;
          }
        }
        return true;
      };
      const _isLocal = compareIp(json.ip, "68.21.116.254");
      set({ isLocal: _isLocal });
      return _isLocal;
    } catch (error) {
      const _isLocal = true;
      set({ isLocal: _isLocal });
      return _isLocal;
    }

    // if(res.ip)
    // const res = await fetch(
    //   `${mchenryServiceCoreUrl}/Authentication/GetIPAddress`
    // );
    // "68.21.116.254"
    // const json = await res.json();
    // set({ isLocal: json.IsLocal });
  },
  isLocal: false,
  isAuthLoading: true,
  isAuthenticated: false,
  setIsAuthenticated: (isAuthenticated: boolean) => {
    set({ isAuthenticated });
  },
  userInfo: null,
  setUserInfo: (userInfo) => {
    set({ userInfo });
  },
  refreshAppToken: async (token) => {
    const appname = get().config.authenticationService?.arcGISAppname;

    if (appname) {
      const getArcGISTokenUrl = `${mchenryServiceCoreUrl}/AGOL/GetAppToken?appname=${appname}`;
      const arcGISTokenRes = await fetch(getArcGISTokenUrl, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : get().getAuthHeaders(),
      });
      const arcgisToken = await arcGISTokenRes.text();

      // Case insensitive regex
      const regExp = new RegExp("^https://www.mchenrycountygis.org.*", "i");

      esriConfig.request.interceptors?.push({
        urls: regExp,
        before: function (params) {
          if (
            params.url.toLowerCase().includes("imageserver") ||
            params.url.toLowerCase().includes("imagery")
          ) {
            return;
          }

          params.requestOptions.query = params.requestOptions.query || {};
          params.requestOptions.query.token = arcgisToken;
        },
      });
      const { fetch: originalFetch } = window;
      window.fetch = async (...args) => {
        let [resource, config] = args;
        if (typeof resource === "string" && resource.includes("?f=json")) {
          if (
            resource.toLowerCase().includes("imageserver") ||
            resource.toLowerCase().includes("imagery")
          ) {
            return originalFetch(resource, config);
          }
          if (regExp.test(resource))
            resource = resource.replace(
              "?f=json",
              "?f=json&token=" + arcgisToken
            );
        }
        const response = await originalFetch(resource, config);
        await new Promise((resolve) => setTimeout(resolve, 50));
        return response;
      };
    }
  },

  checkToken: async () => {
    const localStorageTokenKey =
      get().config?.authenticationService?.localStorageTokenKey || "";
    const token = localStorage.getItem(localStorageTokenKey);
    if (!token) {
      return false;
    }

    const tokenUrl = `${mchenryServiceCoreUrl}/Authenticate/ValidateToken?token=${token}`;
    const res = await fetch(tokenUrl);
    if (!res.ok) {
      return false;
    }

    const json = await res.json();

    if (!json.userId) {
      return false;
    }

    const userInfoUrl = `${mchenryServiceCoreUrl}/Users/GetUserInfo?userId=${json.userId}`;
    const userInfoRes = await fetch(userInfoUrl, {
      headers: get().getAuthHeaders(),
    });
    if (!userInfoRes.ok) {
      return false;
    }
    const userInfo = await userInfoRes.json();
    get().setUserInfo(userInfo);

    await get().refreshAppToken();
    get().setIsAuthenticated(true);
    return true;
  },
  checkLogin: async (username, password) => {
    const isTokenValid = await get().checkToken();
    const allowedRoles =
      get().config.authenticationService?.allowedUserRoles || [];
    const localStorageTokenKey =
      get().config.authenticationService?.localStorageTokenKey || "";

    if (isTokenValid) {
      return true;
    }
    if (!username || !password) {
      return false;
    }
    const loginUrl = `${mchenryServiceCoreUrl}/Authenticate/Login`;
    const res = await fetch(loginUrl, {
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, allowedRoles }),
      method: "POST",
      mode: "cors",
    });
    if (!res.ok) {
      return false;
    }
    const data = await res.json();
    await get().refreshAppToken(data.token);
    get().setUserInfo(data.user);
    get().setIsAuthenticated(true);
    localStorage.setItem(localStorageTokenKey, data.token);
    return true;
  },
  logout: () => {
    const localStorageTokenKey =
      get().config.authenticationService?.localStorageTokenKey || "";
    localStorage.removeItem(localStorageTokenKey);
    get().setIsAuthenticated(false);
    get().setUserInfo(null);
  },
});
